module.exports = __webpack_public_path__ + "static/img/renyuanheshi.f90f4db0.png";